import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __spreadArray, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

/**
 * @remarks If using v-wmodel always use the modifier .lazy
 */
var CodeEntryComponent = /** @class */ (function (_super) {
    __extends(CodeEntryComponent, _super);
    function CodeEntryComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.digits = [];
        _this.currentField = null;
        return _this;
    }
    CodeEntryComponent.prototype.handleInput = function (index) {
        var value = this.digits[index].digit || '';
        var nextIndex = index + 1;
        if (value.length > 1) {
            this.processPastedDigits(value.split(''), index);
            return;
        }
        if (this.digits.length > nextIndex &&
            value.length === 1 &&
            !isNaN(+value)) {
            this.currentField = nextIndex;
        }
    };
    CodeEntryComponent.prototype.handlePaste = function (event) {
        var _a;
        event.preventDefault();
        var pastedText = ((_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text')) || '';
        var pastedDigits = pastedText.split('');
        if (pastedDigits.length === 0) {
            return;
        }
        var newDigits = __spreadArray([], this.digits);
        for (var i = 0; i < Math.min(this.length, pastedDigits.length); i++) {
            newDigits[i] = { digit: pastedDigits[i] };
        }
        this.digits = newDigits;
        var focusIndex = Math.min(pastedDigits.length, this.length - 1);
        this.currentField = focusIndex;
    };
    CodeEntryComponent.prototype.handleDelete = function (event, index) {
        var field = this.digits[index].digit;
        var prevIndex = index - 1;
        if (prevIndex >= 0 && (field === '' || field === null)) {
            event.detail[0].preventDefault();
            this.currentField = prevIndex;
        }
    };
    CodeEntryComponent.prototype.handleBeforeInput = function (event, index) {
        if (event.inputType === 'insertFromPaste' && event.data) {
            event.preventDefault();
            this.processPastedDigits(event.data.split(''), index);
        }
        else if (event.inputType === 'insertText' &&
            event.data &&
            event.data.length > 1) {
            event.preventDefault();
            this.processPastedDigits(event.data.split(''), index);
        }
    };
    CodeEntryComponent.prototype.processPastedDigits = function (pastedDigits, startIndex) {
        if (startIndex === void 0) { startIndex = 0; }
        var newDigits = this.digits.slice();
        for (var i = 0; i < Math.min(this.length - startIndex, pastedDigits.length); i++) {
            var digitIndex = startIndex + i;
            if (digitIndex < this.length) {
                var digit = pastedDigits[i];
                if (/^\d$/.test(digit)) {
                    newDigits[digitIndex] = { digit: digit };
                }
            }
        }
        this.digits = newDigits;
        var focusIndex = Math.min(startIndex + pastedDigits.filter(function (d) { return /^\d$/.test(d); }).length, this.length - 1);
        this.currentField = focusIndex;
    };
    CodeEntryComponent.prototype.digitLengthChange = function () {
        // TODO: Maybe modify the behavior so the below isn't an issue?
        // NOTE: This method must be before `onValueChange` to ensure that
        // the watcher is executed before the length change.
        // Fill then map to generate a new object per index.
        this.digits = new Array(this.length)
            .fill(null)
            .map(function () { return ({ digit: null }); });
    };
    CodeEntryComponent.prototype.onValueChange = function (value) {
        if (value === null || value === undefined) {
            return;
        }
        var splitArr = value
            .split('')
            .map(function (digit) { return ({ digit: digit }); });
        this.digits = splitArr.concat(Array(this.length - value.length)
            .fill(null)
            .map(function () { return ({ digit: null }); }));
    };
    CodeEntryComponent.prototype.digitsChanged = function (digits) {
        var _this = this;
        var code = digits.map(function (_a) {
            var digit = _a.digit;
            return digit;
        }).join('');
        var allDigitsFilled = digits.every(function (d) { return d.digit !== null && d.digit !== ''; });
        // If all digits are filled, emit submit event after a short delay to ensure UI updates
        if (allDigitsFilled && code.length === this.length) {
            setTimeout(function () {
                _this.$emit('submit', code);
            }, 100);
        }
        return code;
    };
    __decorate([
        Prop({ type: Number, default: 4 }),
        __metadata("design:type", Number)
    ], CodeEntryComponent.prototype, "length", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], CodeEntryComponent.prototype, "value", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], CodeEntryComponent.prototype, "disableAutoscroll", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], CodeEntryComponent.prototype, "error", void 0);
    __decorate([
        Watch('length', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CodeEntryComponent.prototype, "digitLengthChange", null);
    __decorate([
        Watch('value', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CodeEntryComponent.prototype, "onValueChange", null);
    __decorate([
        Watch('digits', { deep: true }),
        Emit('change'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CodeEntryComponent.prototype, "digitsChanged", null);
    CodeEntryComponent = __decorate([
        Component({
            name: 'ui-code-entry',
            validations: {
                digits: {
                    $each: {
                        digit: {
                            required: required,
                            minLength: minLength(1),
                            maxLength: maxLength(1),
                        },
                    },
                },
            },
        })
    ], CodeEntryComponent);
    return CodeEntryComponent;
}(Mixins(validationMixin, MagicConfigMixin)));

export default CodeEntryComponent;
